module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAdCAYAAACqhkzFAAAAAXNSR0IArs4c6QAAARFJREFUSEvtlsFRw0AMRfU9vidUgEugg5AOoAI423twByQd+CDvGSogHSQlUEKogHD37GfkiTMJgx3vGe/NI+lJq/njvxARyfP8LkmSFxF5sO/IswkhrL33H1aHI2wrIvNI0Hn6IYSwNCicczsRWfwFS9P0pqqqQxcry3LeNM1XT+Odqi4NyL7JSO4B7Ls4yQxA1pevqhgExq7gAkjyDcBrLITkM4Anq/s94VpVV7FA55zVmEImoMi0w3ECmmRz8XOYZPMfZDPujgNZYz3lUVU3zjnz7Pehri2wKApzttshJ+tiVxzys67rzFzvWuexE7Z5OD5FzLkqALPYRZL8Jll671vHbIFnV7qPBaqqvTxO5wdvAQctUT/rUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview/phone-select.png
// module id = 4nIb
// module chunks = 1